import React, { useEffect } from 'react';

import { MapType } from '@strava/mre';

import { useMREState } from '../../hooks/useMREState';
import { Flyover, FlyoverProps } from '../Flyover/Flyover';

interface FlyoverOnlyProps
  extends Pick<FlyoverProps, 'polyline' | 'elevation' | 'onProgressChanged'> {
  isWinterSport?: boolean;
}

export const FlyoverOnly = ({
  polyline,
  elevation,
  onProgressChanged,
  isWinterSport
}: FlyoverOnlyProps) => {
  const { setIsFlyoverInProgress, setMapType } = useMREState();

  useEffect(() => {
    // On flyover mount, set the map to satellite
    setMapType(
      isWinterSport
        ? MapType.STRAVA_SATELLITE_WINTER
        : MapType.STRAVA_SATELLITE_SUMMER
    );
    // and mark flyover as in progress to hide the controls
    setIsFlyoverInProgress(true);

    return () => {
      setIsFlyoverInProgress(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flyover
      polyline={polyline}
      elevation={elevation}
      playbackSpeedFactor={1.6}
      onProgressChanged={onProgressChanged}
    />
  );
};
